import React, { useEffect, useState } from 'react';
import PubSub from 'services/PubSub/';
import PropTypes from 'prop-types';
import CartActions from 'actions/Cart';
import TagManagerService from 'services/TagManager';
import Loader from 'components/Loader';
import ImageLoad from "components/ImageLoad";

const ItemNotes = (props) => {
    const [product, setProduct] = useState(null);
    const [criteriaId, setCriteria] = useState(6);
    const [addNote, setAddNote] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [placeholder, setPlaceholder] = useState('');
    const pathName = window.location.href;
    
    useEffect(() => {
        const { payload } = props;
        if (payload) {
            setProduct(payload.value ? payload.value.products : null);
            setCriteria(payload.value ? payload.value.criteriaId : null);
            setAddNote(payload.value ? payload.value.note : '');
            setPlaceholder(payload.value ? payload.value.placeholder : '')
        }
    }, [props.payload])


    const saveNote = (e) => {
        setIsLoading(true);
        CartActions.setReplacementCriteria(product.id, criteriaId, addNote).then(()=>{
            setIsLoading(false);
            PubSub.dispatch('add_notes_close');
        })
        e.preventDefault();
        TagManagerService.interaction('Agregar Nota', pathName , 'Agregar Nota');
    }

    return (
        <div className="new-modal-container">
            <div className={'new-modal-scroll'}>
                <span className="modal-add-notes-title">Comentarios</span>
                {product && 
                    <div className="modal-add-notes-product">
                        <ImageLoad src={product.imageUrl} alt={product.name}/>
                        <span className="modal-add-notes-product-title">{product.name}</span>
                    </div>
                }
                <textarea className="modal-add-notes-textarea" placeholder={placeholder ? placeholder : 'Indícanos como quieres este producto (nivel de madurez, tipo de corte, etc.)'} value={addNote} onChange={e => setAddNote(e.target.value)}/>
            </div>
            <div className="modal-actions">
                <button className="primary-btn modal-add-notes-button" onClick={saveNote}>
                    {isLoading && <div className="loader-modal-add-notes"><Loader /></div>}
                    Agregar nota
                </button>
                
            </div>
        </div>
    )
}

ItemNotes.propTypes = {
    payload: PropTypes.object
}

export default ItemNotes;